// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"kbU15JTK"};